import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ThresholdsForCertificationSummarySelectors';
import ThresholdsForCertificationReport from '../../components/ThresholdsForCertificationReport';

export class ThresholdsForCertificationSummaryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLegendThresholdsForCertification: true,
      // eslint-disable-next-line react/no-unused-state
      showModal: true,
    };
  }

  closeChart = () => {
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      showModal: false,
    });
  };

  render() {
    return (
      <ThresholdsForCertificationReport
        reportId={ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        closeChart={this.closeChart}
        showLegendThresholdsForCertification={this.state.showLegendThresholdsForCertification}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ThresholdsForCertificationSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ThresholdsForCertificationSummaryContainer);
